import { apiCoreV3 } from "../apiCoreV3";

export const apiMarkConversationAsRead = async (conversationId: string) => {
  const res = await apiCoreV3.post(
    `/communication/conversations/${conversationId}/mark-as-read`
  );

  return res;
};
